module.exports = __webpack_public_path__ + "static/api-e7300bb7ac602fd56f7bceb796279524.png";